import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import { setTimeFrameRange } from '../../../actions/TVModeAction';

class TVModeModalTimeFrameComponent extends Component {
  state = {
    timeFrameRange: ''
  }

  componentDidMount() {
    this.setState({ timeFrameRange: this.props.timeFrame });
  }

  setRange(range) {
    this.setState({ timeFrameRange: range });
    // this.props.setTimeFrame(range);
    this.props.setTimeFrameRange(range);
  }

  // renderFooter() {
  //   const { timeFrameRange } = this.state;
  //   const { recipient } = this.props;
  //   let isDisabled = timeFrameRange === '';
  //   if (!recipient) {
  //     return (
  //       <div
  //         onClick={() => { if (!isDisabled) this.props.chooseSection('display-options', true, recipient);}}
  //         className={isDisabled ? 'footer-text disabled-button' : 'footer-text'}
  //       >
  //         DISPLAY OPTIONS >
  //       </div>
  //     );
  //   }
  //   else {
  //     return (
  //       <div
  //         onClick={() => { if (!isDisabled) this.props.chooseSection('recipient', true, recipient); }}
  //         className={isDisabled ? 'footer-text disabled-button' : 'footer-text'}
  //       >
  //         SET RECIPIENT >
  //       </div>
  //     );
  //   }

  // }

  render() {
    const { timeFrameRange } = this.state;
    return (
      <div>
        <div style={{ height: '100%' }}>
          <div className="chooseText">Choose a time frame:</div>
          <div className="time-frame-options-holder">
            <Button
              className={timeFrameRange === 'today' ? 'tv-mode-time-frame-options selected' : 'tv-mode-time-frame-options'}
              onClick={() => this.setRange('today')}
            >
              Today
            </Button>
            <Button
              className={timeFrameRange === 'week' ? 'tv-mode-time-frame-options selected' : 'tv-mode-time-frame-options'}
              onClick={() => this.setRange('week')}
            >
              This Week
            </Button>
            <Button
              className={timeFrameRange === 'month' ? 'tv-mode-time-frame-options selected' : 'tv-mode-time-frame-options'}
              onClick={() => this.setRange('month')}
            >
              This Month
            </Button>
            <Button
              className={timeFrameRange === 'all' ? 'tv-mode-time-frame-options selected' : 'tv-mode-time-frame-options'}
              onClick={() => this.setRange('all')}
            >
              All Time
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ tvModeStore }) => {
  const { timeFrame } = tvModeStore;
  return { timeFrame };
};

const TVModeModalTimeFrame = connect(mapStateToProps, { setTimeFrameRange })(TVModeModalTimeFrameComponent);
export { TVModeModalTimeFrame };


// WEBPACK FOOTER //
// ./src/screens/dashboard/TVModeModalSections/TVModeModalTimeFrame.js